import React from "react";

export default function MarketStyle() {
    return (
        <style type="text/css">{`
             .live-table-title {
                text-align: right;
                padding-right: 0;
                font-size: 14px;
            }
            
            .range-selectors {
                text-align: left;
                margin-top: 3px;
                font-size: 13px;
                padding-left: 0
            }
            
            .date-range-btn {
                padding: 5px 7px;
                cursor: pointer;
            }
            
            .disabled {
                color: #ccc;
                cursor: default;
            }
            
            .half-content {
                width: 50%;
            }
            
            #chartjs-tooltip {
                opacity: 1;
                position: absolute;
                text-align: right;
                background: rgba(0, 0, 0, .9);
                box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.8);
                color: #fff;
                border-radius: 6px;
                padding: 50px;
                pointer-events: none;
            }
            
            #chartjs-tooltip {
                border-collapse: collapse;
                border-spacing: 1px;
                padding: 0;
                margin: 0;
            }
            
            .tooltip-title {
                color: #fff;
                font-size: 12px;
                text-align: center !important;
            }
            
            .tooltip-value {
                color: #fff;
                font-size: 12px;
            }
            
            .tooltip-value sup {
                font-size: 12px;
            }
            
            .tooltip-currency-symbol {
                display: inline;
                margin-right: 5px;
                margin-bottom: 2px;
            }
            
            .colored-rectangle {
                width: 13px;
                height: 13px;
                text-align: right;
                border: 1px solid #fff;
                display: inline-block;
            }
            
            .bottom:after {
                bottom: 97%;
                left: 17px;
                content: " ";
                position: absolute;
                pointer-events: none;
                border: 8px solid rgba(255, 255, 255, 0);
                border-bottom-color: rgba(0, 0, 0, .9);
                margin-left: -15px;
            }
            `}
        </style>
    );
}
